import mitt from "mitt";

type Events = {
  onFrameUpdated: number;
  onSampleUpdated: string[];
};

/**
 * Ticker is responsible for running animation at fixed rate
 */
export const createTicker = () => {
  let fpsInterval = 0;
  let lastDrawTime = 0;
  let lastSampleTime = 0;
  const maxSamples = 30;
  let requestID: number, intervalID: NodeJS.Timeout;
  let frameCount = 0;
  const samples = ["fps"];

  const emitter = mitt<Events>();

  function sampleFps() {
    // sample FPS
    const now = performance.now();
    if (frameCount > 0) {
      const currentFps = ((frameCount / (now - lastSampleTime)) * 1000).toFixed(
        2
      );

      frameCount = 0;

      // Save the FPS sample for graphing
      samples.push(currentFps);
      if (samples.length > maxSamples + 1) {
        samples.splice(1, samples.length - (maxSamples + 1));
      }

      emitter.emit("onSampleUpdated", samples);
    }
    lastSampleTime = now;
  }

  function animate(now: DOMHighResTimeStamp) {
    // calc elapsed time since last loop

    // request another frame
    requestID = requestAnimationFrame(animate);

    const elapsed = now - lastDrawTime;
    // if enough time has elapsed, draw the next frame
    if (elapsed >= fpsInterval) {
      // Get ready for next frame by setting lastDrawTime=now, but...
      // Also, adjust for fpsInterval not being multiple of 16.67
      lastDrawTime = now - (elapsed % fpsInterval);

      // We're passing static value instead of elapsed
      // because we want to avoid skipping frames snapshots when rAF slow down
      emitter.emit("onFrameUpdated", fpsInterval);

      // draw
      frameCount++;
    }
  }

  function startAnimating(fps: number, sampleFreq: number) {
    fpsInterval = 1000 / fps;
    lastDrawTime = performance.now();
    lastSampleTime = lastDrawTime;
    frameCount = 0;

    animate(0);

    intervalID = setInterval(sampleFps, sampleFreq);
  }

  return {
    run() {
      startAnimating(30, 1000);
    },
    pause() {
      clearInterval(intervalID);
      cancelAnimationFrame(requestID);
    },
    on: emitter.on,
    off: emitter.off,
  };
};
